import Tooltip from '@mui/material/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faList, faRadiation, faFingerprint } from '@fortawesome/free-solid-svg-icons';
import ConsumerServiceStyles from './ConsumerServiceIcon.styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import AllOutIcon from '@mui/icons-material/AllOut';
import { CONSUMER_SERVICE } from './ConsumerServiceConstants';
import NRFileBinaryIcon from '../../NRIcons/NRFileBinaryIcon';
import NRSBOMIcon from '../../NRIcons/NRSBOMIcon';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles(ConsumerServiceStyles);

export function hasConsumerServiceIcon(serviceName) {
  const servicesWithIcons = [
    CONSUMER_SERVICE.CVE,
    CONSUMER_SERVICE.EXTRACT,
    CONSUMER_SERVICE.SBOM,
    CONSUMER_SERVICE.MACHINE_LEARNING,
    CONSUMER_SERVICE.PARSER,
    CONSUMER_SERVICE.FIRMWARE.toUpperCase(),
    CONSUMER_SERVICE.SBOM.toUpperCase()
  ];

  return servicesWithIcons.includes(serviceName);
}

export default function ConsumerServiceIcon({ serviceName }) {
  const theme = useTheme();
  const classes = useStyles();
  switch (serviceName) {
    case CONSUMER_SERVICE.CVE:
      return (
        <Tooltip title={CONSUMER_SERVICE.CVE_LABEL}>
          <span aria-hidden className={clsx(classes.roundedIcon, classes.iconRed, classes.margin)}>
            <FontAwesomeIcon icon={faRadiation} style={{ width: 16 }} />
          </span>
        </Tooltip>
      );
    case CONSUMER_SERVICE.EXTRACT:
      return (
        <Tooltip title={CONSUMER_SERVICE.EXTRACT_LABEL}>
          <span aria-hidden className={clsx(classes.roundedIcon, classes.iconRed, classes.margin, classes.materialIcon)}>
            <AllOutIcon style={{ verticalAlign: '-0.125em', width: '16px', height: '18px' }} />
          </span>
        </Tooltip>
      );
    case CONSUMER_SERVICE.SBOM:
      return (
        <Tooltip title={CONSUMER_SERVICE.SBOM_LABEL}>
          <span aria-hidden className={clsx(classes.roundedIcon, classes.iconGray, classes.margin)}>
            <FontAwesomeIcon icon={faList} style={{ width: 16 }} />
          </span>
        </Tooltip>
      );
    case CONSUMER_SERVICE.MACHINE_LEARNING:
      return (
        <Tooltip title={CONSUMER_SERVICE.MACHINE_LEARNING_LABEL}>
          <span aria-hidden className={clsx(classes.roundedIcon, classes.iconBlue, classes.margin)}>
            <FontAwesomeIcon icon={faBrain} style={{ width: 16 }} />
          </span>
        </Tooltip>
      );
    case CONSUMER_SERVICE.PARSER:
      return (
        <Tooltip title={CONSUMER_SERVICE.PARSER_LABEL}>
          <span aria-hidden className={clsx(classes.roundedIcon, classes.iconYellow, classes.margin)}>
            <FontAwesomeIcon icon={faFingerprint} style={{ width: 16 }} />
          </span>
        </Tooltip>
      );
    case CONSUMER_SERVICE.FIRMWARE.toUpperCase():
      return (
        <Tooltip title={CONSUMER_SERVICE.BINARY_LABEL}>
          <span aria-hidden style={{ display: 'flex', alignItems: 'center' }}>
            <NRFileBinaryIcon color={theme.palette.text.iconInfo} />
          </span>
        </Tooltip>
      );
    case CONSUMER_SERVICE.SBOM.toUpperCase():
      return (
        <Tooltip title={CONSUMER_SERVICE.SBOM_LABEL}>
          <span aria-hidden style={{ display: 'flex', alignItems: 'center' }}>
            <NRSBOMIcon color={theme.palette.text.iconInfo} />
          </span>
        </Tooltip>
      );
    default:
      return null;
  }
}
